import { render, staticRenderFns } from "./userDetailsHeader.vue?vue&type=template&id=659ce1b5"
import script from "./userDetailsHeader.vue.ts?vue&type=script&lang=ts&external"
export * from "./userDetailsHeader.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports